import { agentApi } from "./index";

export interface AgentListParams {
  ids?: Array<string>;
  companyId?: string;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  conditionsIds?: Array<string>;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  offset?: number;
  limit?: number;
  sort?: "createdAt" | "updatedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: AgentListParams, options?: any) => {
  return agentApi.Agent.listAgent(
    params.ids,
    params.companyId,
    params.firstName,
    params.lastName,
    params.middleName,
    params.conditionsIds,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    options
  );
};
